/***
 * a11y.js - Shopify Accessibility Remediation Layer
 *
***/

// PDP desktop gallery: expose the currently selected thumbnail.
(function () {
  const desktopGalleries = document.querySelectorAll(
    '.product__media-container.above-mobile [data-product-thumbnails]'
  );

  desktopGalleries.forEach(function (gallery) {
    const thumbnails = gallery.querySelectorAll('[data-product-thumbnail]');

    function syncCurrentThumbnail() {
      thumbnails.forEach(function (thumbnail) {
        if (thumbnail.classList.contains('active')) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
    }

    syncCurrentThumbnail();

    gallery.addEventListener('click', function (event) {
      const thumbnail = event.target.closest('[data-product-thumbnail]');

      if (!thumbnail || !gallery.contains(thumbnail)) return;

      requestAnimationFrame(syncCurrentThumbnail);
    });
  });
})();